// extracted by mini-css-extract-plugin
export default {"input-error-message":"InputErrorMessage_input-error-message__E7+nL"};